'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  DRAG_AND_DROP: null,
  CODED_FILE: null
});